import localforage from 'localforage';


const surveys = localforage.createInstance({
  name: "surveys"
});

const answers = localforage.createInstance({
  name: "answers"
});

const settings = localforage.createInstance({
  name: "settings"
})

export { surveys, answers, settings }